(() => {
  const source = document.getElementById('KrArrowIconTemplate')?.content.querySelector('svg');
  if (!source) return;

  function install(targetDocument) {
    if (!targetDocument.body || targetDocument.documentElement.dataset.krArrowIconsReady) return;
    targetDocument.documentElement.dataset.krArrowIconsReady = 'true';
    const directions = { '↗':'up-right', '↖':'up-left', '↘':'down-right', '↙':'down-left', '→':'right', '←':'left', '↑':'up', '↓':'down' };
    const containsArrow = /[↗↖↘↙→←↑↓]/u;
    const arrowPattern = /([↗↖↘↙→←↑↓])[\uFE0E\uFE0F]?/gu;
    const skip = 'script,style,textarea,input,select,option,svg,template,noscript,code,pre,[contenteditable]:not([contenteditable="false"]),.kr-arrow-icon';
    function replaceText(node) {
      const parent = node.parentElement;
      if (!parent || !containsArrow.test(node.data) || parent.closest(skip) || !parent.closest('a,button,summary,[role="button"]')) return;
      const fragment = targetDocument.createDocumentFragment();
      let offset = 0;
      for (const match of node.data.matchAll(arrowPattern)) {
        fragment.append(targetDocument.createTextNode(node.data.slice(offset, match.index)));
        const icon = targetDocument.createElement('span');
        icon.className = 'kr-arrow-icon';
        icon.dataset.krArrowDirection = directions[match[1]];
        icon.setAttribute('aria-hidden', 'true');
        icon.append(source.cloneNode(true));
        fragment.append(icon);
        offset = match.index + match[0].length;
      }
      fragment.append(targetDocument.createTextNode(node.data.slice(offset)));
      const control = parent.closest('a,button,summary,[role="button"]');
      if (control.matches('[data-action="journey-enlarge"]') && !control.hasAttribute('aria-label')) {
        control.setAttribute('aria-label', 'Enlarge preview');
      }
      node.replaceWith(fragment);
    }
    function scan(root) {
      if (root.nodeType === Node.TEXT_NODE) return replaceText(root);
      if (root.nodeType !== Node.ELEMENT_NODE || root.matches(skip)) return;
      const walker = targetDocument.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) if (containsArrow.test(walker.currentNode.data)) nodes.push(walker.currentNode);
      nodes.forEach(replaceText);
    }
    scan(targetDocument.body);
    const pending = new Set();
    let scheduled = false;
    function flush() {
      scheduled = false;
      const nodes = [...pending]; pending.clear();
      nodes.forEach(node => { if (node.isConnected) scan(node); });
    }
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') pending.add(record.target);
        else record.addedNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE) pending.add(node);
        });
      });
      if (pending.size && !scheduled) { scheduled = true; requestAnimationFrame(flush); }
    }).observe(targetDocument.body, { childList: true, subtree: true, characterData: true });
  }

  install(document);

  // The DIY configurator is rendered in a same-origin srcdoc iframe.
  const stylesheet = document.querySelector('link[rel="stylesheet"][href*="/kr-arrow-icons.css"]');
  function installInStudio(frame) {
    const studio = frame.contentDocument;
    if (!studio?.body || studio.URL !== 'about:srcdoc' || !stylesheet) return;
    if (!studio.documentElement.dataset.krArrowIconsReady) {
      const link = studio.createElement('link');
      link.rel = 'stylesheet';
      link.href = stylesheet.href;
      studio.head.append(link);
    }
    install(studio);
  }

  const watchedFrames = new WeakSet();
  function connectStudio() {
    const frame = document.querySelector('iframe#kinriot-diy-frame');
    if (!frame || watchedFrames.has(frame)) return;
    watchedFrames.add(frame);
    frame.addEventListener('load', () => installInStudio(frame));
    if (frame.contentDocument?.readyState === 'complete') installInStudio(frame);
  }

  connectStudio();
  if (document.getElementById('kinriot-diy-mount')) {
    new MutationObserver(connectStudio).observe(document.body, { childList: true });
  }
})();
